// extracted by mini-css-extract-plugin
export default {"body":"List_body__b9Nrj","bodyRow":"List_bodyRow__VeyLS"};